import { cloneDeep } from "lodash";
import { nanoid } from "nanoid";
import { getVal } from 'oolib'
 
export const _HANDLE_DUPLICATE_BLOCK = ({
    block, 
    blockAryPath, 
    blockIdx,
    setTplConfig,
    SAVE_TPL_CHANGES
}) => {
    setTplConfig((prev) => {
      let newTplConfig = cloneDeep(prev);
      let thisAry = getVal( newTplConfig, blockAryPath);

      /*
        User should change the tag category from the dropdown after duplicating,
        for the components "TagsInputSingle" and "TagsInputMulti".
        Otherwise, save won't be possible as duplicate valuePath is not allowed.
        Not adding hash suffix for these comps because their valuePath should always be something like
        tags.country, tags.states, etc (it should be tags.tagType)
      */
      const compsWithoutSuffixForDupsValuePath = ["TagsInputSingle", "TagsInputMulti"];
      let newValuePath =
        block.valuePath +
        (compsWithoutSuffixForDupsValuePath.includes(block.comp)
          ? ""
          : "_" + nanoid(4));
      /**
       * pending dynamic setting of 'copy_1', 'copy_2' etc for valpath and id
       */
      thisAry.splice(blockIdx + 1, 0, {
        ...block,
        valuePath: newValuePath,
        props: { ...block.props, id: newValuePath },
      });

      SAVE_TPL_CHANGES({newTplConfig});

      return newTplConfig;
    });
  };